import { useEffect } from "react";
import { FacebookIcon, FacebookShareButton } from "react-share";

import cn from "classnames";
import "./ArticleModalContent.scss";

import { ThumbSlider } from "components/ThumbSlider";
import { FacebookComment } from 'components/FacebookComment';
import { useIntl } from "react-intl";

export interface showArticleModalProps {
  show: boolean;
  value: number;
  index: number;
}

export type ArticleContentProps = {
  image: string;
  date: string;
  title: string;
  text: React.ReactNode;
  className?: string;
  sliderContent?: any;
  type?: string;
};

declare global {
  interface Window {
    FB: any;
  }
}

export const ArticleModalContent = ({
  image,
  date,
  title,
  text,
  className,
  sliderContent,
  type
}: ArticleContentProps) => {
  // useEffect(() => {
  //   if (window.FB) {
  //     window.FB.XFBML.parse();
  //   }
  // }, []);

  let sliderData = [];

  for (const image in sliderContent?.gallery) {
    sliderData.push(sliderContent?.gallery[image]);
  }
  const { formatMessage } = useIntl();

  return (
    <div className={cn(className, "article-modal-content")}>
      <div className="article-modal-content__image-wrapper">
        <img
          className="article-modal-content__image"
          src={image}
          alt={title}
          loading="lazy"
        />
      </div>
      <div className="article-modal-content__date">{date}</div>
      <h1 className="article-modal-content__header">{title}</h1>
     <div className="article-modal-content__text">{text}</div>
      {!type && text && (
        <>
          {" "}
          <div className="article-modal-content__socialBtn">
            <FacebookShareButton
              url={window.location.href}
              quote="test"
              hashtag="test"
            >
              <FacebookIcon size={32} round={true} />
            </FacebookShareButton>
          </div>
        
        </>
      )}
      {sliderData[0] && (
        <>
          <div className="article-slider">
            <h4>{formatMessage({
                  id: "gallery.title",
                  defaultMessage: "_gallery_",
                })}</h4>
            <ThumbSlider
              sliderData={sliderData?.map((slide) => (
                <img src={slide?.original_url} alt="" loading="lazy" />
              ))}
            />
          </div>
        </>
      )}

<FacebookComment
                link={`${window.location.href}`}
                title={formatMessage({
                  id: "blog.comments",
                  defaultMessage: "_comments_",
                })}
            />
    </div>
  );
};
